import Service from "./general";
import { XML2JSON, XML2TextForecast } from "../scripts/Treatment";
import { timeBeginForecast, hour, timeEndForecast } from "../scripts/date";

const indicators = "99,100,101,102,103,369";
const indicatorsText = "367";
const indicatorWindDirection = "101";

const URL = `https://sensor.krasn.ru/sc/api/1.0/projects/10/aggvalues?&sites=4226&key=f6q6kbspmw7p47gr&time_begin=${timeBeginForecast} ${hour}:00:00&time_end=${timeEndForecast} ${hour}:00:00&time_interval=1hour&indicators=${indicators}`;
const URL_WIND_DIRECTION = `https://sensor.krasn.ru/sc/api/1.0/projects/10/aggvalues?&sites=4226&key=f6q6kbspmw7p47gr&time_begin=${timeBeginForecast} 00:00:00&time_end=${timeEndForecast} 23:00:00&time_interval=1hour&indicators=${indicatorWindDirection}`;
const URL_TEXT = `https://sensor.krasn.ru/sc/api/1.0/projects/10/values.xml?&time_begin=${timeBeginForecast}&time_end=${timeEndForecast} 23:00:00&key=f6q6kbspmw7p47gr&indicators=${indicatorsText}`;

const forecastService = new Service({ url: URL, func: XML2JSON });
const forecastWindDirectionService = new Service({ url: URL_WIND_DIRECTION, func: XML2JSON });
const forecastTextService = new Service({ url: URL_TEXT, func: XML2TextForecast });

export { forecastService, forecastWindDirectionService, forecastTextService };
